import * as React from "react";
import { CommunicationHistory, Page } from "../../types";
import moment from "moment";
import { CommunicationHistoryAction } from "../types";

interface OwnProps {
  histories: Page<CommunicationHistory> | null;
  getMoreHistory: () => void;
}

interface OwnState {
  submitDisabled: boolean;
}

type Props = OwnProps;

class CommunicationHistoryDetail extends React.PureComponent<Props, OwnState> {
  public constructor(props: Props) {
    super(props);

    this.state = {
      submitDisabled: true
    };
  }

  private getMoreHistory = () => {
    this.props.getMoreHistory();
  };

  public render() {
    const { histories } = this.props;
    return (
      <>
        <div className="section p-15 mt-25">
          <div className="title">Communication History</div>
          <div className="mt-20">
            <div className="flex full-width list-header">
              <div className="flex-1">Action</div>
              <div className="flex-1 pl-5 pr-5">Sent</div>
              <div className="flex-1">Details</div>
            </div>
            {histories &&
              histories.results.map((history, index) => (
                <div key={index} className="mt-10">
                  <div className="flex full-width">
                    <div className="flex-1">{CommunicationHistoryAction[history.action]}</div>
                    <div className="flex-1 pl-5 pr-5">
                      {history.user && (
                        <div>
                          {history.user.firstName} {history.user.lastName}
                        </div>
                      )}
                      <div>{moment(history.created).format("LLL")}</div>
                    </div>
                    <div className="flex-1 break-word">{history.details}</div>
                  </div>
                </div>
              ))}
          </div>
          {histories && histories.next && (
            <button className="mt-15" onClick={this.getMoreHistory}>
              Show More History
            </button>
          )}
        </div>
      </>
    );
  }
}

export default CommunicationHistoryDetail;
